<template>
  <div class="chat">
    <TextBalloon
      dark
      v-if="done"
      :src="require('@/assets/images/chat/government.svg')"
    >
      Een administratieve rompslomp telkens jare voor die luttele 7 a 8 procent der groote kiezersmassa
    </TextBalloon>
    <TextBalloon
      dark
      v-if="showMinister"
      :src="require('@/assets/images/chat/minister.svg')"
      class="chat-balloon-minister"
    >
      <HeelSchraal />
    </TextBalloon>
  </div>
</template>

<script>
import TextBalloon from '@/components/chat'
import { fadeMixin } from '@/mixins'
import HeelSchraal from './HeelSchraal'

export default {
  name: 'Chat',
  data () {
    return {
      showMinister: false
    }
  },
  components: {
    TextBalloon,
    HeelSchraal
  },
  mixins: [fadeMixin],
  watch: {
    done () {
      setTimeout(() => {
        this.showMinister = true
      }, 2200)
    }
  }
}
</script>

<style lang="scss" scoped>
.chat {
  margin: 0 auto;
  padding: 100px 0;

  @media (min-width: 768px) {
    padding: 150px 0;
  }
}

.chat-balloon-minister {
  font-size: 0;
}
</style>
